import type { LayerKey } from '@festina-life/api'
import { notEmpty, type Optional } from '@festina-life/core'
import { FormikSelect } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import { useMetaModelContext } from '../../context/metaModelContext'
import { useLazyLayerMetaModel } from '../../context/useLazyLayerMetaModel'
import { isEnumMetaType } from '../../types/metaModel'
import { getLiteralName } from '../../uiModels/enumLiterals/helpers'
import { getApplicationViewConfiguredEnums } from '../../workspace/helpers'
import { useOperationsContext } from '../../workspace/operationsContext'
import { validateKey } from './helpers'

type Props = {
  layer: Optional<LayerKey>
  isDisabled: boolean
}

export const ParameterDraftTypeInputs = ({ layer, isDisabled }: Props) => {
  const translate = useTranslate()
  const { layerTopology, blockTopology } = useMetaModelContext()
  const { configuredEnums } = useOperationsContext()
  const rootBlock = blockTopology.name
  const metaModel = useLazyLayerMetaModel(layer?.layerId)

  const applicationEnumDefinitions = layer
    ? getApplicationViewConfiguredEnums({
        configuredEnums,
        layer,
        layerTopology,
        block: rootBlock, // FIXME fix this once the draft creation form supports block selection.
        blockTopology,
      })
    : undefined
  const parameterTypeDefinition =
    applicationEnumDefinitions?.get('ParameterType')

  const environmentTypeDefinition = applicationEnumDefinitions?.get(
    'ParameterEnvironmentType',
  )

  const modeledParameterType = metaModel.types.get('ParameterType')
  const modeledEnvironmentType = metaModel.types.get('ParameterEnvironmentType')

  return (
    <>
      <FormikSelect
        options={(
          parameterTypeDefinition?.literals ??
          (isEnumMetaType(modeledParameterType) &&
          modeledParameterType?.values?.length
            ? modeledParameterType.values
                .filter(notEmpty)
                .map((literalName) => ({
                  type: 'modeled',
                  literalName,
                  enumDefinition: modeledParameterType,
                }))
            : [])
        ).map(getLiteralName)}
        name={validateKey('parameterType')}
        label={translate('parameterDraftForm.parameterType.label')}
        disabled={isDisabled}
        sort={false}
      />
      <FormikSelect
        options={(
          environmentTypeDefinition?.literals ??
          (isEnumMetaType(modeledEnvironmentType) &&
          modeledEnvironmentType?.values?.length
            ? modeledEnvironmentType.values
                .filter(notEmpty)
                .map((literalName) => ({
                  type: 'modeled',
                  literalName,
                  enumDefinition: modeledEnvironmentType,
                }))
            : [])
        ).map(getLiteralName)}
        name={validateKey('environmentType')}
        label={translate('parameterDraftForm.environmentType.label')}
        disabled={isDisabled}
      />
    </>
  )
}
